// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'transform';

export const Component = () => (
  <path d='M24.521 11.831c0-1.054-.383-1.963-1.101-2.73C22.653 8.384 21.743 8 20.69 8s-1.963.383-2.682 1.102c-.767.766-1.15 1.676-1.15 2.73 0 1.052.383 1.963 1.15 2.681.719.767 1.628 1.15 2.682 1.15s1.963-.383 2.73-1.15c.718-.718 1.101-1.628 1.101-2.682ZM9.195 15.663 4.598 8.001 0 15.663h9.195Zm4.742-2.97-2.107 1.964.622.719 2.73-2.49h.048l.335-.336.335-.288-.048-.047.048-.048-.335-.287-.335-.335h-.048l-2.73-2.491-.622.719 2.107 1.963H8.813v.958h5.124Z' />
);

export const viewBox = '0 0 25 25';
